import React from 'react';
import './servicequadsection.css';
import { FcCheckmark } from "react-icons/fc";
import serviceContent from '../../../content/pages/service.json';

const ServiceQuadSection = () => {
    const { heading, description1, description2, image1, image2, benefitsHeading, benefits } = serviceContent.equipment;

    return (
        <div className="service-quad-section">
            <div className="quad-item quad-text">
                <h2>{heading}</h2>
                <p>{description1}</p>
                <p>{description2}</p>
            </div>
            <div className="quad-item quad-image quad-image-1" style={{ backgroundImage: `url(${image1})` }}></div>
            <div className="quad-item quad-image" style={{ backgroundImage: `url(${image2})` }}></div>
            <div className="quad-item quad-text">
                <h2>{benefitsHeading}</h2>
                <ul>
                    {benefits.map((benefit, index) => (
                        <li key={index}><FcCheckmark /> {benefit}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ServiceQuadSection;
